import { HttpClient } from "@angular/common/http";
import { BaseService } from "./base-service.service";
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { Application } from "@intellio/shared/models";
import { WebhookService } from './webhook.service';
import { map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProjectsService extends BaseService {
    constructor(
        protected client: HttpClient,
        protected configService: AppConfigService,
        protected authService: AuthService,
        private webhookService: WebhookService
    ) {
        super(client, configService, authService);
    }

    getProject(projectId: number) {
        const projectUrl = 
            `/api/projects/${projectId}`;
        return this.get<Application[]>(projectUrl);
    }
    
    getProjectApplications(projectId: number) {
        const projectAppsUrl = 
            `/api/projects/${projectId}/applications`;
        return this.get<Application[]>(projectAppsUrl);
    }

    updateApplicationProjects(removeLink: boolean, newProjectId: number, applicationIds: string[], initialAppId?: string, projectName?: string) {
        const appProjectUrl = 
            `/api/projects/applications`; 
        return this.post<string>(appProjectUrl, { removeLink, newProjectId, applicationIds, initialAppId, projectName });
    }

    autoGenerateProjectId(appId, categoryId, jurisdictionId, webhookName, overrideExistingProjectId) {
        let data = {
          ApplicationId: appId,
          ApplicationCategoryId: categoryId, 
          JurisdictionId: jurisdictionId,
          OverrideExistingProjectId : overrideExistingProjectId
        };
        return this.webhookService.postWebhook(webhookName, data).pipe(
          map((res: any) => {
            return res.data;
          })
        );
      }
}
